__turbopack_context__.v({
  "dd": "dl-module__VNLorq__dd",
  "dl": "dl-module__VNLorq__dl",
  "dt": "dl-module__VNLorq__dt",
});
